<div class="create-object__wrapper">
  <div class="create-object" [formGroup]="formGroup">
    <tui-scrollbar class="create-object__tabs-scroll">
      <div class="create-object__tabs">
        @for (tab of settingsTabs; track tab; let i = $index) {
          <button (click)="currentTab = tab" [class.is-active]="currentTab === tab">
            {{ tab | translate }}
          </button>
        }
      </div>
    </tui-scrollbar>
    <tui-scrollbar class="create-object__content-scroll">
      <div
        class="create-object__content"
        [style.display]="currentTab === 'General' ? 'flex' : 'none'"
      >
        <div class="row">
          <span>{{ 'LOGIN' | translate }} *</span>
          <tui-textfield [tuiTextfieldCleaner]="false">
            <input
              tuiTextfield
              type="text"
              translate="no"
              formControlName="username"
              [invalid]="
                formGroup.controls['username'].invalid && formGroup.controls['username'].touched
              "
              [placeholder]="'Enter login' | translate"
            />
          </tui-textfield>
          <tui-error [error]="formGroup.get('username')?.errors?.['message']" />
          @if (formGroup.get('username')?.errors?.['maxlength']) {
            <tui-error [error]="'Ensure this field has no more than 150 characters' | translate" />
          }
        </div>

        <div class="row">
          <span>{{ 'First name' | translate }} *</span>
          <tui-textfield [tuiTextfieldCleaner]="false">
            <input
              tuiTextfield
              type="text"
              translate="no"
              formControlName="fullname"
              [invalid]="
                formGroup.controls['fullname'].invalid && formGroup.controls['fullname'].touched
              "
              [placeholder]="'Enter full name' | translate"
            />
          </tui-textfield>
          <tui-error [error]="formGroup.get('fullname')?.errors?.['message']" />
          @if (formGroup.get('fullname')?.errors?.['maxlength']) {
            <tui-error [error]="'Ensure this field has no more than 150 characters' | translate" />
          }
        </div>

        <div class="row">
          <span>{{ 'E-mail' | translate }} *</span>
          <tui-textfield [tuiTextfieldCleaner]="false">
            <input
              tuiTextfield
              type="email"
              translate="no"
              formControlName="email"
              [invalid]="formGroup.controls['email'].invalid && formGroup.controls['email'].touched"
              placeholder="example&#64;example.example"
            />
          </tui-textfield>
          <tui-error [error]="formGroup.get('email')?.errors?.['message']" />
        </div>

        <div class="flex-row">
          <div class="row">
            <span>{{ 'language' | translate }}</span>
            <tui-textfield
              tuiChevron
              [stringify]="stringify(availableLanguages)"
              [tuiTextfieldCleaner]="false"
            >
              <input tuiSelect formControlName="language" />
              <tui-data-list *tuiTextfieldDropdown>
                @for (item of availableLanguages; track item) {
                  <button new tuiOption type="button" [value]="item.id">
                    {{ item.title }}
                  </button>
                }
              </tui-data-list>
            </tui-textfield>
          </div>

          <div class="row">
            <span>{{ 'timezone' | translate }}</span>
            <tui-textfield
              tuiChevron
              [stringify]="stringify(availableTimezones)"
              [tuiTextfieldCleaner]="false"
            >
              <input tuiSelect formControlName="timezone" />
              <tui-data-list *tuiTextfieldDropdown>
                @for (item of availableTimezones; track item) {
                  <button new tuiOption type="button" [value]="item.id">
                    {{ item.title }}
                  </button>
                }
              </tui-data-list>
            </tui-textfield>
          </div>
        </div>

        @if (access_edit_credentials) {
          <div class="row">
            <span>{{ 'Password' | translate }}</span>
            <div>
              <button tuiButton appearance="transparent" (click)="openChangePasswordDialog()">
                {{ 'Change password' | translate }}
              </button>
            </div>
          </div>
        }
        @if (versionInfo) {
          <div class="row">
            <pre class="user-general-info">{{ versionInfo }}</pre>
          </div>
        }
      </div>

      <div [style.display]="currentTab === 'Additional' ? 'contents' : 'none'">
        <tui-accordion>
          <tui-accordion-item [size]="'s'" [borders]="'top-bottom'">
            {{ 'Address display format' | translate }}
            <div tuiAccordionItemContent>
              <div
                #addressFormatList
                cdkDropList
                class="list-container"
                (cdkDropListDropped)="drop($event, this.availableAddressFormat)"
              >
                @for (item of availableAddressFormat; track item) {
                  <!-- desktop: ручек нет, тянется вся строка; телефон: только ручка справа -->
                  <div
                    class="content-item"
                    cdkDrag
                    cdkDragLockAxis="y"
                    (cdkDragStarted)="onAddressFormatDragStarted()"
                    (cdkDragReleased)="onAddressFormatDragReleased()"
                    (cdkDragEnded)="isDragging = false"
                    [class]="isDragging ? 'grabbing' : 'grab'"
                  >
                    <ng-template cdkDragPreview [matchSize]="true">
                      <div class="cdk-drag-preview-custom">
                        <tui-icon class="grabbing" [icon]="'@tui.grip-vertical'" />
                        <p>{{ item.name | translate }}</p>
                      </div>
                    </ng-template>
                    @if (!isMobile()) {
                      <tui-icon
                        [class]="isDragging ? 'grabbing' : 'grab'"
                        [icon]="'@tui.grip-vertical'"
                      />
                    }
                    <label tuiLabel>
                      <input
                        tuiCheckbox
                        type="checkbox"
                        [formControl]="item?.control"
                        [size]="'s'"
                      />
                      {{ item.name | translate }}
                    </label>
                    @if (isMobile()) {
                      <span class="content-item__handle" cdkDragHandle>
                        <tui-icon icon="@tui.grip-vertical" />
                      </span>
                    }
                  </div>
                }
              </div>
            </div>
          </tui-accordion-item>

          <tui-accordion-item [size]="'s'" [borders]="'top-bottom'">
            {{ 'Displaying information in the object card' | translate }}
            <div tuiAccordionItemContent>
              <!-- Таблица: строка на элемент карточки, колонка чекбоксов на каждый тип карточки -->
              <div
                class="object-card-settings"
                [style.--object-card-kinds-count]="objectCardKinds.length"
              >
                <div class="object-card-settings__header">
                  <span class="object-card-settings__title">
                    {{ 'element' | join: ['objectCardKind'] | translate }}
                  </span>
                  @for (kind of objectCardKinds; track kind) {
                    <span class="object-card-settings__kind">
                      {{ kind | join: ['objectCardKind'] | translate }}
                    </span>
                  }
                </div>

                <!-- Поля блока «Основная информация»: порядок фиксирован, перетаскивать нельзя -->
                <div class="general-content-group">
                  @for (item of availableGeneralContent; track item.name) {
                    <div class="content-item locked">
                      <tui-icon class="lock" [icon]="'@tui.lock'" />
                      <span class="content-item__name">
                        {{ item.name | join: ['objectCard'] | translate }}
                      </span>
                      @for (kind of objectCardKinds; track kind) {
                        <input
                          tuiCheckbox
                          type="checkbox"
                          class="content-item__checkbox"
                          [formControl]="item.controls[kind]"
                          [size]="'s'"
                        />
                      }
                    </div>
                  }
                </div>

                <div class="general-content-divider"></div>

                <div
                  #objectCardList
                  cdkDropList
                  class="drop-list"
                  (cdkDropListDropped)="drop($event, this.availableSettingsObjectCard)"
                >
                  @for (item of availableSettingsObjectCard; track item.name) {
                    <!-- desktop: ручек нет, тянется вся строка; телефон: только ручка справа -->
                    <div
                      class="content-item"
                      [class]="isDragging ? 'grabbing' : 'grab'"
                      cdkDrag
                      cdkDragLockAxis="y"
                      (cdkDragStarted)="onObjectCardDragStarted()"
                      (cdkDragReleased)="onObjectCardDragReleased()"
                      (cdkDragEnded)="isDragging = false"
                    >
                      <ng-template cdkDragPreview [matchSize]="true">
                        <div class="cdk-drag-preview-custom">
                          <tui-icon class="grabbing" [icon]="'@tui.grip-vertical'" />
                          <p>{{ item.name | join: ['objectCard'] | translate }}</p>
                        </div>
                      </ng-template>
                      @if (!isMobile()) {
                        <tui-icon
                          [class]="isDragging ? 'grabbing' : 'grab'"
                          [icon]="'@tui.grip-vertical'"
                        />
                      }
                      <span class="content-item__name">
                        {{ item.name | join: ['objectCard'] | translate }}
                      </span>
                      @for (kind of objectCardKinds; track kind) {
                        <input
                          tuiCheckbox
                          type="checkbox"
                          class="content-item__checkbox"
                          [formControl]="item.controls[kind]"
                          [size]="'s'"
                        />
                      }
                      @if (isMobile()) {
                        <span class="content-item__handle" cdkDragHandle>
                          <tui-icon icon="@tui.grip-vertical" />
                        </span>
                      }
                    </div>
                  }
                </div>
              </div>
            </div>
          </tui-accordion-item>

          <tui-accordion-item [size]="'s'" [borders]="'top-bottom'">
            {{ 'Object display on the map' | translate }}
            <div tuiAccordionItemContent>
              <div class="map-object-settings">
                <div class="map-object-settings__header">
                  <span class="map-object-settings__label">
                    {{ 'White background of the object icon' | translate }}
                  </span>
                </div>

                <app-object-icon-opacity-slider formControlName="backgroundOpacity" />
              </div>
            </div>
          </tui-accordion-item>

          @if (currentProjectIsMonitoring) {
            <tui-accordion-item [size]="'s'" [borders]="'top-bottom'">
              {{ 'Displaying tabs in the navigation menu' | translate }}
              @if (availableVisibleTabsNames?.length) {
                <div
                  tuiAccordionItemContent
                  orientation="vertical"
                  tuiGroup
                  class="group"
                  [collapsed]="true"
                >
                  @for (tab of availableVisibleTabsNames; track tab) {
                    <label tuiBlock="s" class="accordion-block">
                      <tui-icon [icon]="tab?.iconSrc" />
                      <span tuiTitle>{{ tab?.title | translate }}</span>
                      <input tuiCheckbox type="checkbox" [formControl]="tab.control" />
                    </label>
                  }
                </div>
              }
            </tui-accordion-item>
          }
          <tui-accordion-item [size]="'s'" [borders]="'top-bottom'">
            {{ 'sensorPrecisionConfig.label' | translate }}
            <div tuiAccordionItemContent tuiGroup>
              <form tuiForm [formGroup]="sensorsSettingsForm">
                @for (item of sensorControlNames; track item) {
                  <div class="selectors">
                    <label tuiLabel> {{ 'sensorPrecisionConfig.' + item | translate }} </label
                    ><tui-textfield
                      tuiChevron
                      tuiTextfieldSize="m"
                      [stringify]="stringifyService.stringifyTranslateValue(sensorsPrecision)"
                      [tuiTextfieldCleaner]="false"
                    >
                      <input tuiSelect [formControlName]="item" />
                      <tui-data-list *tuiTextfieldDropdown>
                        @for (item of sensorsPrecision; track item.id) {
                          <button new tuiOption type="button" [value]="item.id">
                            {{ item.title | translate }}
                          </button>
                        }
                      </tui-data-list>
                    </tui-textfield>
                  </div>
                }
              </form>
            </div>
          </tui-accordion-item>
        </tui-accordion>
      </div>
    </tui-scrollbar>
  </div>

  <div class="btn-block">
    <div>
      <button tuiButton type="button" appearance="outline" (click)="onCancel()">
        {{ 'Cancel' | translate }}
      </button>
      <button tuiButton (click)="onSave()">
        {{ 'SAVE' | translate }}
      </button>
    </div>
  </div>
</div>
